import { useTranslation } from 'react-i18next';

import { useSession } from '@/features/auth/useSession';

/**
 * Why a reader cannot interact right now, or undefined if they can.
 *
 * Spec §5: unverified accounts may read but not post, comment or vote. Saying
 * *which* of those two applies is the difference between a control that looks
 * broken and one that explains itself.
 */
export function useInteractionGate(): string | undefined {
  const { t } = useTranslation();
  const { isSignedIn, needsEmailVerification, isLoading } = useSession();

  if (isLoading) return t('gate.checking');
  if (!isSignedIn) return t('gate.signIn');
  if (needsEmailVerification) return t('gate.verify');

  return undefined;
}
